import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, IconButton, Typography } from '@mui/material';
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined';
import Icon from '@mdi/react';
import { mdiDotsHorizontal } from '@mdi/js';
import MealBasketWidget from '../../features/end_user_shopping/components/meal_basket_widget';
import RecipeCollectionAddNewMealButton from './recipe_collection_add_new_meal_button';
import RecipeCollectionFullWidthMealCard from './recipe_collection_full_width_meal_card';
import RecipeCollectionMenuActionsMenu from './recipe_collection_menu_actions_menu';
import { recipeCollectionsCardDOMID } from '../../services/meals';
import {
  useGetSharedBoardQuery,
  useGetSmorgBoardQuery,
} from '../../app/smorgAppSyncGraphQLApi';
import { SHARED_BOARDS_REFRESH_INTERVAL_SECONDS } from '../../services/end_user_published_resources';

const RecipeSingleCollectionMenuView = () => {
  const navigate = useNavigate();

  const { boardID, menuID } = useParams();

  const { data: ownRecipesBoard } = useGetSmorgBoardQuery(boardID, {
    skip: !boardID,
  });

  const { data: sharedRecipesBoard } = useGetSharedBoardQuery(boardID, {
    skip: !boardID,
    refetchOnMountOrArgChange: SHARED_BOARDS_REFRESH_INTERVAL_SECONDS,
  });

  const [menuActionsMenuAnchorEl, setMenuActionsMenuAnchorEl] = useState(null);

  const onClickMenuActionsMenu = (ev) => {
    setMenuActionsMenuAnchorEl(ev.target);
  };

  const onDismissMenuActionsMenu = () => {
    setMenuActionsMenuAnchorEl(null);
  };

  const recipesBoard = ownRecipesBoard || sharedRecipesBoard;

  const isSharedBoard = !ownRecipesBoard;

  const isReadOnly = isSharedBoard;

  if (!recipesBoard) {
    return null;
  }

  const theMenu = recipesBoard.menus.find((m) => m.id === menuID);

  if (!theMenu) {
    return null;
  }

  return (
    <>
      <MealBasketWidget />
      <div className="collections-view">
        <div className="topNavBarMobile" style={{ flexDirection: 'column' }}>
          <Box
            className="sticky-on-mobile"
            style={{ borderBottom: '1px solid #e1e1e1' }}>
            <div className="popup-title-back-button">
              <IconButton aria-label="back" onClick={() => navigate(-1)}>
                <ArrowBackIosOutlinedIcon />
              </IconButton>
            </div>
            <div className="popup-title-close-button">
              <IconButton
                aria-label="more"
                aria-controls="long-menu"
                aria-haspopup="true"
                size="small"
                onClick={onClickMenuActionsMenu}>
                <Icon
                  path={mdiDotsHorizontal}
                  style={{
                    width: '24px',
                    height: '24px',
                    color: 'var(--app-primary-font-color)',
                  }}
                />
              </IconButton>
            </div>
            <div
              style={{
                padding: '8px',
                textAlign: 'center',
              }}>
              <Typography variant="popupTitle">{recipesBoard.title}</Typography>
            </div>
          </Box>
        </div>
        <div
          style={{
            marginTop: '20px',
          }}>
          <h1 style={{ marginLeft: '23px' }}>{recipesBoard.title}</h1>
          <h2 style={{ marginLeft: '23px' }}>{theMenu.title}</h2>

          {!isReadOnly && (
            <RecipeCollectionAddNewMealButton
              boardID={boardID}
              menuID={menuID}
            />
          )}
          <div
            style={{ display: 'flex', flexWrap: 'wrap', marginLeft: '15px' }}>
            {(theMenu.mealIDs || theMenu.sharedMealIDs).map((mealID) => (
              <div
                key={mealID}
                id={recipeCollectionsCardDOMID(mealID)}
                style={{ flexShrink: 0 }}>
                <RecipeCollectionFullWidthMealCard
                  mealID={mealID}
                  parentID={boardID}
                  menuID={menuID}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      {menuActionsMenuAnchorEl && (
        <RecipeCollectionMenuActionsMenu
          boardID={boardID}
          menuID={menuID}
          isSharedBoard={isSharedBoard}
          anchorEl={menuActionsMenuAnchorEl}
          onDismiss={onDismissMenuActionsMenu}
        />
      )}
    </>
  );
};

export default RecipeSingleCollectionMenuView;
